import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';

import {
  getAccommodationBookingSchedule,
  guestsSumSeats,
  isParticipantInfo
} from 'utils/bookings/prepareBookingsData';
import BookingPriceDetailsPanel from '../booking-price-total/BookingPriceDetails';

import { GuestsDetailsInformation } from 'components';

import useStyles from './styles';

const UpcomingAccommodationDialog = ({
  open,
  booking,
  onClose,
  total,
  onCancel
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [t] = useTranslation();

  if (Object.keys(booking).length === 0) {
    return null;
  }
  return (
    <Dialog open={open} classes={{ paper: classes.paper }}>
      <IconButton className={classes.closeBtn} onClick={onClose}>
        <HighlightOffIcon className={classes.closeIcon} />
      </IconButton>
      <DialogTitle
        id="alert-dialog-title"
        classes={{ root: classes.title }}
        disableTypography={true}
      >
        {booking.referenceNumber} • {booking.guestFirstName}{' '}
        {booking.guestLastName}
      </DialogTitle>
      <DialogTitle
        id="alert-dialog-title"
        classes={{ root: classes.unitTitle }}
        disableTypography={true}
      >
        {booking.accommodation.title}
      </DialogTitle>
      <DialogContent classes={{ root: classes.contentRoot }}>
        <List className={classes.root}>
          <ListSubheader className={classes.subheader}>
            {t('Number of guests')}
          </ListSubheader>
          <ListItem className={classes.listItem}>
            {guestsSumSeats(booking.guests)}
            {isParticipantInfo(booking.guests) && (
              <>
                {' '}
                (<GuestsDetailsInformation guestsInfo={booking.guests} />)
              </>
            )}
          </ListItem>
          <ListSubheader className={classes.subheader}>
            {t('Checkin - checkout')}
          </ListSubheader>
          <ListItem className={classes.listItem}>
            {getAccommodationBookingSchedule(booking)}
          </ListItem>

          <ListSubheader className={classes.subheader}>
            {t('Platform')}
          </ListSubheader>
          <ListItem className={classes.listItem}>{booking.platform}</ListItem>
          {!booking.isCanceled && total && (
            <BookingPriceDetailsPanel priceDetails={total} />
          )}
        </List>
      </DialogContent>
      <DialogActions classes={{ root: classes.actionsRoot }}>
        <Button
          variant="contained"
          classes={{ root: classes.actionBtnRoot }}
          onClick={e => {
            e.stopPropagation();
            history.push(`/accommodations-bookings/${booking.id}/edit`);
          }}
        >
          {t('Edit')}
        </Button>
        <Button
          variant="outlined"
          onClick={e => {
            e.stopPropagation();
            onClose();
            onCancel(booking);
          }}
          classes={{ root: classes.cancelBtnRoot }}
        >
          {t('Cancel Accommodation')}
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          classes={{ root: classes.cancelBtnRoot }}
        >
          {t('Back')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpcomingAccommodationDialog;
